import { render, staticRenderFns } from "./DeliverySlotExceptionForm.vue?vue&type=template&id=c048e668&scoped=true"
import script from "./DeliverySlotExceptionForm.vue?vue&type=script&lang=js"
export * from "./DeliverySlotExceptionForm.vue?vue&type=script&lang=js"
import style0 from "./DeliverySlotExceptionForm.vue?vue&type=style&index=0&id=c048e668&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c048e668",
  null
  
)

export default component.exports